import { Link, useSearchParams } from "react-router-dom";
import { XCircle } from "lucide-react";
import SiteHeader from "../components/SiteHeader";

export default function CancelPage() {
  const [params] = useSearchParams();
  const bookingId = params.get("booking_id");
  return (
    <div className="min-h-screen bg-[#FAFAFA]">
      <SiteHeader />
      <div className="max-w-2xl mx-auto px-4 py-12">
        <div className="ws-card p-8 text-center" data-testid="cancel-card">
          <XCircle className="w-12 h-12 text-[#C85A41] mx-auto mb-3" strokeWidth={1.5} />
          <h1 className="text-3xl font-extrabold mb-2" style={{ fontFamily: "Manrope" }}>Payment cancelled</h1>
          <p className="text-[#5C5C5C] mb-6">
            No worries — your appointment slot is still being held. You can try again or choose to pay at the clinic.
          </p>
          {bookingId && <p className="text-xs text-[#5C5C5C] mb-4">Reference: {bookingId}</p>}
          <Link to="/" className="ws-btn-primary inline-block" data-testid="cancel-restart">Start over</Link>
        </div>
      </div>
    </div>
  );
}
